import { Box, Image } from "theme-ui";
import { useTranslation } from "react-i18next";

import { AppPostsExamplesProps } from "./AppPostsExamples.d";
import { extractBaseLang } from "src/utils";
import posts_en from "src/assets/images/Vecinos_Posts_EN.png";
import posts_es from "src/assets/images/Vecinos_Posts_ES.png";

const imgSelector = (lang: string) => {
  switch (lang) {
    case "es":
      return <Image src={posts_es} alt="Posts" />;
    default:
      return <Image src={posts_en} alt="Posts" />;
  }
};

export const AppPostsExamples: React.FC<AppPostsExamplesProps> = (props) => {
  const { i18n } = useTranslation();
  const currentLanguage = extractBaseLang(i18n.language);
  return <Box {...props}>{imgSelector(currentLanguage)}</Box>;
};
